import clsx from "clsx";

import { FCCC } from "@/types";

type SectionBackground = "none" | "primary" | "secondary";

const backgroundClassMapping: Record<SectionBackground, string> = {
  none: "",
  primary: "bg-background-primary",
  secondary: "bg-background-secondary",
};

/**
 * A tinted section has to reach the edges of the viewport, so it cancels the
 * horizontal padding ContentContainer puts around every child and restores it
 * inside.
 */
const bleedClassName =
  "-mx-4 px-4 tablet:-mx-6 tablet:px-6 desktop:-mx-8 desktop:px-8";

interface Props {
  background?: SectionBackground;
  /** Content column width. "narrow" is the 704px column of the DS screens. */
  width?: "narrow" | "full";
  /** Vertical section padding from the spacing tokens. */
  spacing?: "none" | "vertical";
}

/**
 * One content block of a redesigned page: a full-bleed background band with the
 * content centred in the design system's content column.
 */
export const PageSection: FCCC<Props> = ({
  children,
  className,
  background = "none",
  width = "narrow",
  spacing = "vertical",
}) => (
  <div
    className={clsx(
      backgroundClassMapping[background],
      background !== "none" && bleedClassName,
      spacing === "vertical" && "py-section-padding-vertical",
    )}
  >
    <div
      className={clsx(
        "mx-auto w-full",
        width === "narrow" && "max-w-[704px]",
        className,
      )}
    >
      {children}
    </div>
  </div>
);
